export type ReleaseChangeKind = 'new' | 'improved' | 'fixed';

export interface ReleaseNote {
  readonly id: string;
  readonly date: string;
  readonly title: string;
  readonly changes: readonly {
    readonly id: string;
    readonly kind: ReleaseChangeKind;
    readonly title: string;
    readonly description: string;
  }[];
}

/** Newest first. Add a new, stable ID for each update; dates label this catalog, not deployment. */
export const releaseNotes: readonly ReleaseNote[] = [
  {
    id: '2026-11-04-dashboard-delivery',
    date: '2026-11-04',
    title: 'Faster navigation and clearer delivery tools',
    changes: [
      {
        id: 'dashboard-quick-menu',
        kind: 'new',
        title: 'Your daily tools, one tap away',
        description:
          'Open Sales, Accounts and Inventory directly from the Dashboard quick menu. You see the options available to your account.',
      },
      {
        id: 'courier-handover',
        kind: 'new',
        title: 'Courier handover worksheets',
        description:
          'Select ready courier shipments in Delivery, then choose Documents → Courier handover. Preview and print A4 lists grouped by courier, with space for parcel counts and signatures.',
      },
      {
        id: 'mobile-dashboard-period',
        kind: 'improved',
        title: 'More room on your mobile dashboard',
        description:
          'Date filters start collapsed on mobile. Tap Filters to expand them; your selected period stays visible.',
      },
      {
        id: 'delivery-update-layout',
        kind: 'fixed',
        title: 'Delivery updates without overlapping controls',
        description:
          'Scroll through courier details while the heading and action buttons stay visible. Required fields remain reachable on smaller screens.',
      },
    ],
  },
];
